import { OptionDto } from "@/dtos";
import { TripPatternCheckpointType } from "@/helpers/types";

const types = [
    { value: TripPatternCheckpointType.START_END, label: 'Inicio a Fin' },
    { value: TripPatternCheckpointType.INTERMEDIATE, label: 'Intermedio' },
    { value: TripPatternCheckpointType.END_START, label: 'Fin a Inicio' },
] as OptionDto[];

export const getTripPatternCheckpointTypeOptions = (): OptionDto[] => {
    return types;
}

export const getTripPatternCheckpointTypeOption = (value?: number): OptionDto => {
    return types.find((x) => x.value == value) ?? types[0];
}